import { createSelector, createFeatureSelector } from '@ngrx/store';
import { CopModuleState, copModuleKey } from '../cop';
import * as fromCameras from './cameras.reducer';
import { getLvtToken } from "./cameras.reducer";

const selectCopModuleState = createFeatureSelector<CopModuleState>(copModuleKey);

const selectCamerasState = createSelector(selectCopModuleState, (state: CopModuleState) => state?.cameras);

export const selectTrafficStream = createSelector(selectCamerasState, fromCameras.getCurrentTrafficStream);

export const selectTrafficCameraImage = createSelector(selectCamerasState, fromCameras.getTrafficImage);

export const selectVideoStreams = createSelector(selectCamerasState, fromCameras.getVideoStreams);

export const selectCameraStreamUrl = createSelector(selectCamerasState, fromCameras.getCameraStreamUrl);

export const selectCameraImageUrl = createSelector(selectCamerasState, fromCameras.getCameraImageUrl);

export const selectVmsCameraMedia = createSelector(selectCamerasState, fromCameras.getVmsCameraMediaData);

export const selectLiveViewToken = createSelector(selectCamerasState, fromCameras.getLvtToken);
